import IResult from '../../models/result/IResult';
import { sendPost, sendPut } from './generic';

export interface DeepAnalysisUpsellValue {
    dollarValue: number;
    displayName: string;
    hidden?: boolean;
    isHidden?: boolean;
}

export type DeepAnalysisUpsellValuesByTag = Record<string, DeepAnalysisUpsellValue>;

export const syncDeepAnalysisUpsellValues = (organizationId: string, groupId?: string): Promise<IResult<DeepAnalysisUpsellValuesByTag>> => {
    const query = `organizationId=${encodeURIComponent(organizationId)}${groupId ? `&groupId=${encodeURIComponent(groupId)}` : ''}`;
    return sendPost<DeepAnalysisUpsellValuesByTag>(`/DeepAnalysis/UpsellValues/Sync?${query}`, {});
};

export const updateDeepAnalysisUpsellValues = (organizationId: string, values: DeepAnalysisUpsellValuesByTag): Promise<IResult<DeepAnalysisUpsellValuesByTag>> => {
    return sendPut<DeepAnalysisUpsellValuesByTag>(`/DeepAnalysis/UpsellValues/${encodeURIComponent(organizationId)}`, values);
};
